import { useApiAction } from "api/drops/useApiAction";
import { userListTelephoneApi } from "api/puzzel/puzzel";
import { usePuzzelAuthenticationContext } from "features/Header/PuzzelTelephone/provider/contexts/PuzzelAuthenticationContext";
import { UserDetailsAndLogOnOffProvider } from "features/Header/PuzzelTelephone/provider/contexts/UserDetailsAndLogOnOffContext";
import { useSetUserValidation } from "features/Header/PuzzelTelephone/provider/contexts/UserValidationContext";
import { CallProvider } from "features/Header/PuzzelTelephone/provider/providers/CallStatusProvider";
import { ReactNode, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "shared/components/typography/TitleStyles";
import { useUserInfo } from "shared/hooks/useUserInfo";

type Props = {
  children: ReactNode;
};
const ValidateUserAndPresentLogon = (props: Props) => {
  const setUserId = useSetUserValidation();
  const { isAuthenticated } = usePuzzelAuthenticationContext();
  const { username } = useUserInfo();
  const { t } = useTranslation();

  const [userListRequest, performGetUserList] = useApiAction(
    userListTelephoneApi,
    false,
  );

  useEffect(() => {
    if (isAuthenticated) {
      performGetUserList();
    }
  }, [isAuthenticated]);

  const foundUserId = userListRequest.data?.result?.find(
    (it: any) => it.userName === username,
  )?.id;

  useEffect(() => {
    if (foundUserId) {
      setUserId({
        userId: foundUserId,
      });
      localStorage.setItem("puzzelUserId", foundUserId);
    } else {
      setUserId({
        userId: null,
      });
      localStorage.removeItem("puzzelUserId");
    }
  }, [foundUserId]);

  if (!foundUserId) {
    return (
      <Text
        style={{
          marginRight: "2.5rem",

          // Behaviour: Use max 3 lines and show "..." at overflow
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: "3",
          WebkitBoxOrient: "vertical",
        }}
      >
        {t(
          "Bruker ({{username}}) er ikke registrert i Puzzel. Ta kontakt med admin",
          { username },
        )}
      </Text>
    );
  }

  const { children } = props;
  return (
    <UserDetailsAndLogOnOffProvider>
      <CallProvider>{children}</CallProvider>
    </UserDetailsAndLogOnOffProvider>
  );
};

export default ValidateUserAndPresentLogon;
